import {
  CalendarStep,
  CheckboxStep,
  CounterStep,
  RadioStep,
  SelectStep,
} from '../Steps';

export const StepperPage = ({
  generateAnswersObject,
  page,
  questions,
  answerItem,
}) => {
  const answerTypes = {
    checkbox: 'checkbox',
    select: 'select',
    counter: 'counter',
    calendar: 'calendar',
  };

  const currentQuestion = questions.data?.find((item) => item.position === page);

  const StepComponent =
    currentQuestion?.answer_type === answerTypes.checkbox
      ? CheckboxStep
      : currentQuestion?.answer_type === answerTypes.select
        ? SelectStep
        : currentQuestion?.answer_type === answerTypes.counter
          ? CounterStep
          : currentQuestion?.answer_type === answerTypes.calendar
            ? CalendarStep
            : RadioStep;

  if (!currentQuestion) {
    return null;
  }

  return (
    <StepComponent
      generateAnswersObject={generateAnswersObject}
      answerItem={answerItem}
      currentQuestion={currentQuestion}
    />
  );
};
